import { render } from "./package_services.html?vue&type=template&id=5a5771a6&external"
import script from "./package_services.js?vue&type=script&lang=js&external"
export * from "./package_services.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__